module.exports = __webpack_public_path__ + "static/media/45.f8a06201.mp3";